<template>
<div class="m-0 p-0">
    <b-form-group label="Filtrar por NSU:" label-for="filter-nsu">
        <b-form-input id="filter-nsu" v-model="nsuFilter" placeholder="Digite o NSU para filtrar"></b-form-input>
    </b-form-group>

    <b-table class="text-center" :per-page="8" hover :current-page="page" responsive :items="filteredItems" :fields="[
        {
          key: 'nsu',
          label: 'NSU'
        },
        {
          key: 'transactionDate',
          label: 'Data da Transação'
        },
        {
          key: 'chargebackId',
          label: 'id do chargeback'
        },
        {
          key: 'incomingDate',
          label: 'Data da Solicitação'
        },
        {
          key: 'processNumber',
          label: 'Número do Processo'
        },
        {
          key: 'status',
          label: 'Status'
        },
        {
          key: 'value',
          label: 'Valor'
        },
        {
          key: 'postedRate',
          label: 'Taxas'
        },
      ]" @row-clicked="item => $emit('row-clicked', item.chargebackId ,item.nsu, item.transactionDate)">
        <template #cell(transactionDate)="data">
            {{ data.item.transactionDate | date }}
        </template>

        <template #cell(incomingDate)="data">
            {{ data.item.incomingDate | date }}
        </template>

        <template #cell(value)="data">
            {{ data.item.value | value }}
        </template>

        <template #cell(postedRate)="data">
            {{ data.item.postedRate ? 'Sim' : 'Não' }}
        </template>
    </b-table>

    <b-pagination v-model="page" :total-rows="filteredItems.length" :per-page="8" align="center" size="sm" class="my-2" />
</div>
</template>

<script>
import {
    BTable,
    BPagination,
    BFormGroup,
    BFormInput,
} from 'bootstrap-vue';

export default {
    components: {
        BTable,
        BPagination,
        BFormGroup,
        BFormInput,
    },

    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            page: 1,
            nsuFilter: "",
        };
    },

    computed: {
        filteredItems() {
            return this.items.filter(item =>
                item.nsu.toString().includes(this.nsuFilter.trim())
            );
        },
    },
};
</script>
